import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const noop = () => {};

class FormField extends Component {
  static propTypes = {
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    value: PropTypes.string.isRequired,
    hasError: PropTypes.bool,
  }

  static defaultProps = {
    onFocus: noop,
    onBlur: noop,
    type: 'text',
    hasError: false,
  }

  state = {
    hasFocus: false
  }

  handleFocus = () => {
    this.props.onFocus();
    this.setState({ hasFocus: true });
  }

  handleBlur = () => {
    this.props.onBlur();
    this.setState({ hasFocus: false });
  }

  render () {
    const { hasFocus } = this.state;
    const { hasError, name, label, value, onChange, ...props } = this.props;

    const className = classNames('FormField', {
      'is-validation-error': hasError,
      'is-focused': hasFocus,
      'is-filled': value.length > 0,
    });

    return (
      <div className={className}>
        <label htmlFor={name} className="FormField-label">{label}</label>
        <input
          {...props}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onChange={onChange}
          placeholder={label}
          value={value}
          id={name}
          className="FormField-input" />
      </div>
    );
  }
}

export default FormField;
